import React from 'react'
import { inject, observer } from 'mobx-react'

import { userStore    } from 'sdc-auth-user'
import { CreateButton } from '../../components/buttons'

export const CreateTextButton = inject('textsStore')(observer(({authStore,textsStore}) =>
<CreateButton title="text.create" onClick={textsStore.create({
  owner  : userStore.user.id,
  values: {
    created: new Date().valueOf(),
  },
})} />))
